import { cn } from "@utils/index";
import { BiLoaderAlt } from "react-icons/bi";

interface Props {
  size?: string;
  thickNess?: string;
}
export const CircularProgressIndicator = () => {
  return <BiLoaderAlt className="animate-spin" />;
};

interface LoadingContainerProps extends React.ComponentPropsWithoutRef<"div"> {
  label?: string;
  progressIndicatorProps?: Props;
}

export const LoadingContainer = ({ label, className, ...props }: LoadingContainerProps) => {
  return (
    <div className={cn("flex h-full w-full flex-col items-center justify-center gap-8 bg-background ", className)} {...props}>
      {label && <h1 className="text-xl font-bold">{label}</h1>}
      <CircularProgressIndicator />
    </div>
  );
};
